import {createFileRoute} from '@tanstack/react-router';
import {LanguagePage} from '../../../../features/settings/pages/LanguagePage';

export const Route = createFileRoute('/_protected/home/service/language')({
  component: LanguagePage,
  staticData: {crumbKey: 'navigation.language'},
});
